import React, { useEffect, useState } from "react";
import axios from "axios";

const ProductMapping = () => {
  const [centers, setCenters] = useState([]);        // ✅ dynamic centers
  const [leadSources, setLeadSources] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [products, setProducts] = useState([]);

  const [form, setForm] = useState({
    center: "",
    leadSource: "",
    campaign: "",
  });

  const [selectedProducts, setSelectedProducts] = useState([]);
  const [mappingExists, setMappingExists] = useState(false);

  // ✅ Fetch centers, campaigns, lead sources, products once
  useEffect(() => {
    fetchCenters();

    axios
      .get("https://crm-server-htk6.vercel.app/api/campaigns")
      .then((res) => setCampaigns(res.data))
      .catch((err) => console.error("❌ Error fetching campaigns:", err));

    axios
      .get("https://crm-server-htk6.vercel.app/api/leadSources")
      .then((res) => setLeadSources(res.data))
      .catch((err) => console.error("❌ Error fetching lead sources:", err));

    axios
      .get("https://crm-server-htk6.vercel.app/api/products")
      .then((res) => setProducts(res.data))
      .catch((err) => console.error("❌ Error fetching products:", err));
  }, []);

  const fetchCenters = async () => {
    try {
      const res = await axios.get(
        "https://crm-server-htk6.vercel.app/api/centers"
      );
      setCenters(res.data);
    } catch (err) {
      console.error("❌ Error fetching centers:", err);
    }
  };

  // ✅ Fetch existing mapping when center is selected
  const { center, leadSource, campaign } = form;

useEffect(() => {
  if (!center || !leadSource || !campaign) return;

  axios
    .get(
      `https://crm-server-htk6.vercel.app/api/productMappings?center=${center}&leadSource=${leadSource}&campaign=${campaign}`
    )
    .then((res) => {
      if (res.data && res.data._id) {
        setMappingExists(true);
        setSelectedProducts(res.data.products || []);
      } else {
        setMappingExists(false);
        setSelectedProducts([]);
      }
    })
    .catch((err) => console.error("❌ Error fetching mapping:", err));
}, [center, leadSource, campaign]);


  // ✅ Toggle product checkbox
  const toggleProduct = (productName) => {
    if (selectedProducts.includes(productName)) {
      setSelectedProducts(selectedProducts.filter((p) => p !== productName));
    } else {
      setSelectedProducts([...selectedProducts, productName]);
    }
  };

  // ✅ Save mapping
  const handleSave = async () => {
    if (!form.center || !form.leadSource || !form.campaign) {
      return alert("Please select all fields");
    }

    const payload = {
      center: form.center,
      leadSource: form.leadSource,
      campaign: form.campaign,
      products: selectedProducts,
    };

    try {
      if (mappingExists) {
        await axios.put(
          `https://crm-server-htk6.vercel.app/api/productMappings/${form.center}/${form.leadSource}/${form.campaign}`,
          payload
        );
        alert("✅ Mapping updated successfully");
      } else {
        await axios.post(
          "https://crm-server-htk6.vercel.app/api/productMappings",
          payload
        );
        alert("✅ Mapping created successfully");
        setMappingExists(true);
      }
    } catch (err) {
      console.error("❌ Error saving mapping:", err);
      alert("⚠️ Failed to save mapping");
    }
  };

  return (
    <div className="page">
      <h2>Product Mapping</h2>

      {/* Form Section */}
      <div className="form-container">
        <div className="form-row">
          {/* ✅ Dynamic Center Dropdown */}
          <select
            value={form.center}
            onChange={(e) => setForm({ ...form, center: e.target.value })}
          >
            <option value="">Select Center</option>
            {centers.map((c) => (
              <option key={c._id} value={c.centerName}>
                {c.centerName}
              </option>
            ))}
          </select>

          {/* Lead Source Dropdown */}
          <select
            value={form.leadSource}
            onChange={(e) => setForm({ ...form, leadSource: e.target.value })}
          >
            <option value="">Select Lead Source</option>
            {leadSources.map((ls) => (
              <option key={ls._id} value={ls.name}>
                {ls.name}
              </option>
            ))}
          </select>

          {/* Campaign Dropdown */}
          <select
            value={form.campaign}
            onChange={(e) => setForm({ ...form, campaign: e.target.value })}
          >
            <option value="">Select Campaign</option>
            {campaigns.map((c) => (
              <option key={c._id} value={c.campaignName}>
                {c.campaignName}
              </option>
            ))}
          </select>
        </div>

        <button className="save-btn" onClick={handleSave}>
          {mappingExists ? "Update" : "Save"}
        </button>
      </div>

      {/* Product List with Checkbox */}
      <div className="rules-block">
        <h3>Select Products</h3>
        <div className="checkbox-group">
          {products.map((p) => (
            <label key={p._id}>
              <input
                type="checkbox"
                checked={selectedProducts.includes(p.productName)}
                onChange={() => toggleProduct(p.productName)}
              />
              {p.productName}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductMapping;
      